<template>
    <div>
        <ticto-loading v-if="loading" />
        <notification-modal
            :open="add"
            @close="add = false"
            @fetch="
                add = false;
                fetch;
            "
        />
        <div class="my-5">
            <div class="flex items-center justify-between">
                <div class="flex items-center">
                    <DevicePhoneMobileIcon
                        class="mr-2 h-8 w-7 shrink-0 text-gray-400"
                    />
                    <h3 class="mb-5 text-lg font-medium leading-9 dark:text-white">
                        Mobile
                    </h3>
                </div>
                <div class="mb-5 flex gap-2">
                    <router-link
                        to="/mobile/timeline"
                        class="inline-flex items-center justify-center rounded-md bg-gray-600 px-3 py-2 text-sm font-semibold leading-6 text-white shadow transition duration-150 ease-in-out hover:bg-gray-500"
                    >
                        <font-awesome-icon
                            :icon="['fas', 'clock']"
                            class="mr-2"
                        />
                        Timeline
                    </router-link>
                    <router-link
                        to="/mobile/bulk-subscribe"
                        class="inline-flex items-center justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold leading-6 text-white shadow transition duration-150 ease-in-out hover:bg-blue-500"
                    >
                        <font-awesome-icon
                            :icon="['fas', 'upload']"
                            class="mr-2"
                        />
                        Inscrição em Massa
                    </router-link>
                </div>
            </div>

            <filters
                v-model="filters"
                @fetch="
                    pagination.current_page = 1;
                    users = [];
                    next_page_url = false;
                    fetch();
                "
                :loading="loading"
                search-filter
                search-label="Filtre por nome, e-mail, cpf ou cnpj"
                class="my-5"
            >
                <template #actions>
                    <submit-button
                        v-if="hasPermission('mobile.broadcast')"
                        @click.prevent="add = true"
                        :loading="loading"
                    >
                        Broadcast
                    </submit-button>
                </template>
            </filters>

            <div class="mt-10">
                <h3 class="mb-5 text-lg font-medium leading-6 dark:text-white">
                    Dispositivos
                </h3>

                <table-component
                    :loading="loading"
                    :headers="[
                        'Usuário',
                        'Sistema',
                        'Token',
                        'Notificar',
                        'Som Atual',
                        'Tópico Inscrito',
                        'Criado em',
                        'Ações',
                    ]"
                    :pagination="pagination"
                    @fetch="fetch"
                >
                    <tr class="table-cell-sm" v-for="device in devices">
                        <td class="pl-3">
                            {{ device.name }}
                        </td>
                        <td class="text-center">
                            <os-icon :os="device.os" />
                        </td>
                        <td>
                            <span class="block max-w-[100px] truncate">
                                {{ device.token }}
                            </span>
                        </td>
                        <td class="text-center">
                            <CheckCircleIcon
                                v-if="device.app_notificate"
                                class="mx-auto block h-5 w-5 shrink-0 text-green-400"
                                aria-hidden="true"
                            />
                            <font-awesome-icon
                                v-else
                                :icon="['fas', 'xmark']"
                                style="color: #ff0000"
                            />
                        </td>
                        <td>
                            <span
                                v-if="device.sound == 1"
                                class="flex flex-wrap"
                            >
                                Cash is King
                            </span>
                            <span
                                v-if="device.sound == 2"
                                class="flex flex-wrap"
                            >
                                Mario Bros
                            </span>
                            <span
                                v-if="device.sound == 3"
                                class="flex flex-wrap"
                            >
                                Street Figther
                            </span>
                        </td>
                        <td class="text-center">
                            <CheckCircleIcon
                                v-if="device.topic_subscribed"
                                class="mx-auto block h-5 w-5 shrink-0 text-green-400"
                                aria-hidden="true"
                            />
                            <font-awesome-icon
                                v-else
                                :icon="['fas', 'xmark']"
                                style="color: #ff0000"
                            />
                        </td>
                        <td>
                            {{ device.created_at }}
                        </td>
                        <td>
                            <div class="flex flex-wrap gap-1">
                                <button
                                    @click="openModal(device)"
                                    :disabled="loading"
                                    type="button"
                                    :class="{ 'cursor-not-allowed': loading }"
                                    class="inline-flex items-center justify-center rounded-md bg-indigo-500 px-2 py-1 text-sm font-semibold leading-6 text-white shadow transition duration-150 ease-in-out hover:bg-indigo-400"
                                >
                                    <font-awesome-icon
                                        :icon="['fas', 'envelope']"
                                    />
                                    Enviar Notificação
                                </button>
                                
                                <button
                                    @click="openTopicModal(device)"
                                    :disabled="loading"
                                    type="button"
                                    :class="{ 'cursor-not-allowed': loading }"
                                    class="inline-flex items-center justify-center rounded-md bg-blue-500 px-2 py-1 text-sm font-semibold leading-6 text-white shadow transition duration-150 ease-in-out hover:bg-blue-400"
                                >
                                    <font-awesome-icon
                                        :icon="['fas', 'rss']"
                                    />
                                    Gerenciar Tópico
                                </button>
                                
                                <button
                                    @click.prevent="destroy(device.id)"
                                    :disabled="loading"
                                    type="button"
                                    :class="{ 'cursor-not-allowed': loading }"
                                    class="inline-flex items-center justify-center rounded-md bg-red-500 px-2 py-1 text-sm font-semibold leading-6 text-white shadow transition duration-150 ease-in-out hover:bg-red-400"
                                >
                                    <font-awesome-icon :icon="['fas', 'trash']" />
                                    Remover Dispositivo
                                </button>
                            </div>
                        </td>
                    </tr>
                </table-component>
            </div>
        </div>

        <modal class="min-h-full" :open="modal" @close="modal = false">
            <div
                class="flex min-h-fit w-full flex-col flex-wrap space-y-3 divide-y divide-slate-500 text-white"
            ></div>
            <h1
                class="mb-2 flex flex-row flex-wrap content-center items-center border-b border-slate-500 pb-1 text-lg text-sm font-bold text-white"
            >
                Enviar Notificação para {{ device.name }}
            </h1>

            <form @submit.prevent="sendTestNotification">
                <div class="mt-5 flex-col sm:mt-4 sm:flex">
                    <div class="mb-3 grid gap-2 sm:grid-cols-1">
                        <div>
                            <label class="text-white"> Título </label>
                            <input
                                type="text"
                                id="title"
                                v-model="form.title"
                                name="title"
                                class="text-input"
                                placeholder="Título"
                                required
                            />
                        </div>
                        <div>
                            <label class="text-white"> Descrição </label>
                            <input
                                type="text"
                                id="body"
                                v-model="form.body"
                                minlength="10"
                                name="body"
                                class="text-input"
                                placeholder="Descrição"
                                required
                            />
                        </div>

                        <div>
                            <label class="text-white"> Link </label>
                            <input
                                v-model="form.link"
                                type="url"
                                id="link"
                                name="link"
                                class="text-input"
                                placeholder="Link"
                            />
                        </div>

                        <button
                            type="submit"
                            class="ml-2 inline-flex items-center justify-center rounded-md bg-blue-500 px-2 py-1 text-sm font-semibold leading-6 text-white shadow transition duration-150 ease-in-out hover:bg-indigo-400"
                        >
                            Enviar Notificação
                        </button>
                    </div>
                </div>
            </form>
        </modal>

        <!-- Modal para Gerenciar Tópico -->
        <modal class="min-h-full" :open="topicModal" @close="topicModal = false">
            <div
                class="flex min-h-fit w-full flex-col flex-wrap space-y-3 divide-y divide-slate-500 text-white"
            ></div>
            <h1
                class="mb-2 flex flex-row flex-wrap content-center items-center border-b border-slate-500 pb-1 text-lg text-sm font-bold text-white"
            >
                Gerenciar Tópico para {{ device.name }}
            </h1>

            <div class="mt-5">
                <div class="mb-4 text-white">
                    <p class="text-sm text-gray-300">
                        Sistema: 
                        <span class="font-semibold">{{ device.os }}</span>
                    </p>
                    <p class="text-sm text-gray-300">
                        Tópico atual: 
                        <span class="font-semibold text-green-400" v-if="device.topic_subscribed">
                            {{ device.os === 'iOS' ? 'ios' : 'android' }} (Inscrito)
                        </span>
                        <span class="font-semibold text-red-400" v-else>
                            Não inscrito
                        </span>
                    </p>
                </div>

                <div class="flex gap-3">
                    <button
                        v-if="!device.topic_subscribed"
                        @click="subscribeToTopic"
                        :disabled="loading"
                        type="button"
                        :class="{ 'cursor-not-allowed opacity-50': loading }"
                        class="inline-flex items-center justify-center rounded-md bg-green-500 px-4 py-2 text-sm font-semibold leading-6 text-white shadow transition duration-150 ease-in-out hover:bg-green-400"
                    >
                        <font-awesome-icon
                            :icon="['fas', 'plus']"
                            class="mr-2"
                        />
                        Inscrever no Tópico
                    </button>

                    <button
                        v-if="device.topic_subscribed"
                        @click="unsubscribeFromTopic"
                        :disabled="loading"
                        type="button"
                        :class="{ 'cursor-not-allowed opacity-50': loading }"
                        class="inline-flex items-center justify-center rounded-md bg-red-500 px-4 py-2 text-sm font-semibold leading-6 text-white shadow transition duration-150 ease-in-out hover:bg-red-400"
                    >
                        <font-awesome-icon
                            :icon="['fas', 'minus']"
                            class="mr-2"
                        />
                        Desinscrever do Tópico
                    </button>
                </div>

                <div class="mt-4 text-xs text-gray-400">
                    <p>* Os dispositivos iOS são inscritos no tópico "ios"</p>
                    <p>* Os dispositivos Android são inscritos no tópico "android"</p>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
    CheckCircleIcon,
    DevicePhoneMobileIcon,
    StopCircleIcon,
} from "@heroicons/vue/24/outline";
import { useToast } from "vue-toastification";
import UsersSelect from "../../components/forms/UsersSelect.vue";
import VueSelect from "../../components/forms/VueSelect.vue";
import EmptyState from "../../components/layouts/EmptyState.vue";
import Filters from "../../components/layouts/Filters.vue";
import Modal from "../../components/layouts/Modal.vue";
import TictoLoading from "../../components/layouts/TictoLoading.vue";
import Manager from "../../components/manager/Manager.vue";
import StoreModal from "../../components/manager/modals/StoreModal.vue";
import PaginationObject from "../../mixins/PaginationObject.vue";
import TableComponent from "../../components/layouts/table/TableComponent.vue";
import OsIcon from "../../components/layouts/antifraud/OsIcon.vue";
import NotificationModal from "./NotificationModal.vue";
import SubmitButton from "../../components/forms/SubmitButton.vue";
import PermissionMixin from "../../mixins/PermissionMixin.vue";
export default {
    components: {
        SubmitButton,
        NotificationModal,
        OsIcon,
        TableComponent,
        EmptyState,
        StoreModal,
        Manager,
        VueSelect,
        UsersSelect,
        TictoLoading,
        DevicePhoneMobileIcon,
        CheckCircleIcon,
        FontAwesomeIcon,
        StopCircleIcon,
        Filters,
        Modal,
    },
    mixins: [PaginationObject, PermissionMixin],
    setup() {
        const toast = useToast();
        return { toast };
    },
    data() {
        return {
            add: false,
            loading: false,
            modal: false,
            topicModal: false,
            device: null,
            form: {
                body: null,
                title: null,
                link: null,
            },
            devices: [],
            filters: {
                text: "",
            },
            next_page_url: false,
        };
    },

    mounted() {
        this.fetch();
    },

    methods: {
        fetch() {
            this.loading = true;
            const params = this.filters;
            axios
                .get("/api/mobile-devices", {
                    params: {
                        ...params,
                        page: this.pagination.current_page,
                    },
                })
                .then(({ data }) => {
                    this.devices = data.data;
                    this.loading = false;
                    this.setPagination(data);
                });
        },
        openModal(device) {
            this.device = device;
            this.modal = true;
        },
        closeModal() {
            this.device = null;
            this.modal = false;
        },
        openTopicModal(device) {
            this.device = device;
            this.topicModal = true;
        },
        closeTopicModal() {
            this.device = null;
            this.topicModal = false;
        },
        destroy(id) {
            this.loading = true;
            axios
                .delete(`/api/mobile-devices/${id}/destroy`)
                .then(({ data }) => {
                    this.toast.success("Dispositivo deletado com sucesso!");
                    this.fetch();
                    this.loading = false;
                })
                .catch(({ error }) => {
                    this.toast.error("Ocorreu um erro, tente novamente!");
                });
        },
        sendTestNotification() {
            this.loading = true;

            axios
                .post(
                    `/api/mobile-devices/${this.device.id}/send-test`,
                    this.form,
                )
                .then(({ data }) => {
                    this.toast.success(
                        "Notificação teste enviada com sucesso!",
                    );
                    this.closeModal();
                    this.fetch();
                    this.loading = false;
                })
                .catch(({ error }) => {
                    //this.toast.error("Ocorreu um erro, tente novamente!");
                });
        },
        subscribeToTopic() {
            this.loading = true;

            axios
                .post('/api/mobile-devices/topics/subscribe', {
                    device_id: this.device.id
                })
                .then(({ data }) => {
                    this.toast.success('Dispositivo inscrito no tópico com sucesso!');
                    this.device.topic_subscribed = true;
                    this.closeTopicModal();
                    this.fetch();
                    this.loading = false;
                })
                .catch(({ response }) => {
                    const message = response?.data?.message || 'Ocorreu um erro, tente novamente!';
                    this.toast.error(message);
                    this.loading = false;
                });
        },
        unsubscribeFromTopic() {
            this.loading = true;

            axios
                .post('/api/mobile-devices/topics/unsubscribe', {
                    device_id: this.device.id
                })
                .then(({ data }) => {
                    this.toast.success('Dispositivo desinscrito do tópico com sucesso!');
                    this.device.topic_subscribed = false;
                    this.closeTopicModal();
                    this.fetch();
                    this.loading = false;
                })
                .catch(({ response }) => {
                    const message = response?.data?.message || 'Ocorreu um erro, tente novamente!';
                    this.toast.error(message);
                    this.loading = false;
                });
        },
    },
};
</script>
